module.exports = "/_next/static/images/784f64e544a68744b3943c862a7e2eaa-apply-bullet-1.jpeg";